export const claimReasonEnumsConvert = {
    CLEARING_HOUSE: 'CLEARINGHOUSE',
    PAYER: 'PAYER',
    OTHER: 'OTHER',
};
export const claimReasonList = [
    { title: 'Clearinghouse', value: claimReasonEnumsConvert.CLEARING_HOUSE },
    { title: 'Payer', value: claimReasonEnumsConvert.PAYER },
    { title: 'Other', value: claimReasonEnumsConvert.OTHER },
];

// CAS (Claim Adjustment Segment) group codes — X12 835/837 standard.
// Mirrors the outbound-EDI union in
// package/src/clearinghouse/stedi/dto/claim/claim-request.dto.ts
// (`adjustmentGroupCode: 'PR' | 'CO' | 'OA' | 'PI' | 'CR'`). Kept as a
// frontend enum so the modal never inlines raw group-code literals.
export const CAS_GROUP = {
    CO: 'CO',
    PR: 'PR',
    OA: 'OA',
    PI: 'PI',
    CR: 'CR',
};

export const CAS_GROUP_LABEL = {
    [CAS_GROUP.CO]: 'Contractual Obligation',
    [CAS_GROUP.PR]: 'Patient Responsibility',
    [CAS_GROUP.OA]: 'Other Adjustment',
    [CAS_GROUP.PI]: 'Payer Initiated Reduction',
    [CAS_GROUP.CR]: 'Correction and Reversal',
};

// Options for the "Cas group" <SelectInput type="id" /> — { id, name }.
export const casGroupOptions = Object.values(CAS_GROUP).map((code) => ({
    id: code,
    name: `${code} - ${CAS_GROUP_LABEL[code]}`,
}));

// Common CARC (Claim Adjustment Reason Code) descriptions. Used ONLY to
// pre-fill the editable Reason Text when a code is entered — never enforced,
// since the payer's ERA text is authoritative. Extend as needed.
export const CARC_DESCRIPTIONS = {
    1: 'Deductible amount',
    2: 'Coinsurance amount',
    3: 'Co-payment amount',
    45: 'Charge exceeds fee schedule / maximum allowable amount',
    23: 'The impact of prior payer(s) adjudication including payments and/or adjustments',
    253: 'Sequestration - reduction in federal payment',
};

export const getCarcSuggestion = (reasonCode) => {
    if (reasonCode === undefined || reasonCode === null) return '';
    return CARC_DESCRIPTIONS[String(reasonCode).trim()] || '';
};
